import type { ModuleMigrationDef } from "@kubdee/sdk";

// #415 — Migrate fleet maintenance from hardcoded MaintenanceWorkflowStepper to
// the central workflow module. Adds a nullable `workflow_id` column to
// fleet_maintenance_records so each row can bind to the default maintenance
// workflow created by the fleet seed. Backfill happens lazily at create time
// (see routes/maintenance.ts) — existing rows stay null until next write.
export const migration: ModuleMigrationDef = {
  key: "006_add_maintenance_workflow_id",
  version: "1.5.0",
  sql: `
ALTER TABLE \`fleet_maintenance_records\` ADD COLUMN \`workflow_id\` text;
`,
};
